<template>
    <span class="info-tooltip">
        <img src="/images/promo/info-icon.svg" alt="" />
        <div class="tooltip" role="tooltip">
            <div class="tooltip-arrow"></div>
            <div class="tooltip-inner">
                {{ text }}
            </div>
        </div>
    </span>
</template>

<script>
export default {
    props: ["text"],
};
</script>

<style lang="scss" scoped>
.info-tooltip {
    width: 14px;
    height: 14px;
    position: relative;
    img {
        height: 14px;
        width: 14px;
    }
    &:hover {
        .tooltip {
            visibility: visible;
            opacity: 1;
            transition: 0.3s;
        }
    }
    .tooltip {
        visibility: hidden;
        position: absolute;
        transition: 0.3s;
        opacity: 0;
        left: 0px;
        bottom: 0px;
        width: 200px;
    }
}
</style>
